import { Stack } from '../Stack';

export const Stars = () => {
  return (
    <Stack direction="horizontal" spaceX={1} className="inline-flex">
      <div className="flex items-center justify-center w-4 h-4 border border-black rounded-full">
        <div className="w-2.5 h-2.5 bg-black rounded-full" />
      </div>
      <div className="flex items-center justify-center w-4 h-4 border border-black rounded-full">
        <div className="w-2.5 h-2.5 bg-black rounded-full" />
      </div>
      <div className="flex items-center justify-center w-4 h-4 border border-black rounded-full">
        <div className="w-2.5 h-2.5 bg-black rounded-full" />
      </div>
      <div className="flex items-center justify-center w-4 h-4 border border-black rounded-full">
        <div className="w-2.5 h-2.5 bg-black rounded-full" />
      </div>
      <div className="flex items-center justify-center w-4 h-4 border border-black rounded-full">
        <div className="w-2.5 h-2.5 bg-black rounded-full" />
      </div>
    </Stack>
  );
};
